import { string } from './type-checkers.js';
import { wrapType } from './util.js';
const size = string
    .type('size');
const predefinedSize = (customUnits) => {
    return wrapType(string, { customUnits, type: 'size' });
};
export { predefinedSize, size, };
//# sourceMappingURL=size.js.map